// extracted by mini-css-extract-plugin
module.exports = {"zone":"IsolateForm_zone__T5Nm0","zoneInner":"IsolateForm_zone__inner__35pVr","zoneLabel":"IsolateForm_zone-label__2-Azk"};